import React from 'react';
import { Box } from '@hz-design-system/web-ui';
import { ListingDate, ListingPrice, ListingPriority } from '@/client/components/ListingsNew/components';

import Classes from './ListingPriceDateFeature.module.scss';

interface ListingPriceDateFeatureProps {
  price: string;
  date: string;
  priorityProduct: string;
}

const ListingPriceDateFeature: React.FC<ListingPriceDateFeatureProps> = ({ price, date, priorityProduct }) => {
  return (
    <Box
      suppressHydrationWarning
      as="div"
      name="price-date-feature"
      className={Classes['hz-Listing-price-date-feature']}
    >
      <ListingPrice price={price} />
      <ListingDate.Regular date={date} />
      <ListingPriority.Regular priorityProduct={priorityProduct} />
    </Box>
  );
};

export default ListingPriceDateFeature;
